import React from 'react';
interface TestimonialCardProps {
  name: string;
  age: number;
  role: string;
  location: string;
  text: string;
  rating: number;
}
export function TestimonialCard({
  name,
  age,
  role,
  location,
  text,
  rating
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg shadow-lg p-6 border-2 border-blue-100" data-id="element-17">
      <div className="flex items-center gap-1 mb-3" data-id="element-18">
        {[...Array(5)].map((_, i) => <svg key={i} className={`w-5 h-5 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-19">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-20" />
          </svg>)}
      </div>

      <p className="text-gray-700 mb-4 italic leading-relaxed" data-id="element-21">"{text}"</p>

      <div className="border-t pt-4" data-id="element-22">
        <p className="font-bold text-gray-900" data-id="element-23">
          {name}, {age} años
        </p>
        <p className="text-sm text-gray-600" data-id="element-24">{role}</p>
        <p className="text-sm text-blue-600" data-id="element-25">{location}</p>
      </div>
    </div>;
}